export const PACKAGE_NAME = 'inlineConfigProjectHeader';
export const ACTION_SUBJECT = 'input';
export const ACTION_SUBJECT_ID = 'configurableProjectHeader';
